import Vue from 'vue'
import { AlertsService } from './alerts.service'
import moment from 'vue-moment'

export const GlobalUtility = {
  caseException: [
    'status',
    'email',
    'route',
    'password',
    'username',
    'confirmPassword',
    'signature'
  ],

  capitalizeProperties (value) {
    try {
      Object.keys(value).forEach(key => {
        if (value[key] && typeof value[key] === 'string') {
          if (!this.caseException.includes(key)) {
            value[key] = (value[key]) ? String(value[key]).toUpperCase() : ''
          }
        } else {
          value[key] = this.capitalizeProperties(value[key])
        }
      })
    } catch (e) {
      return value
    }
    return value
  },

  deCapitalizeProperties (value) {
    const newValue = {}
    try {
      Object.keys(value).forEach(key => {
        if (!this.caseException.includes(key) &&
            !(typeof value[key] === 'number')) {
          if (typeof value[key] === 'string') {
            newValue[key] = (value[key]) ? String(value[key]).toLowerCase() : ''
          } else if (value[key] === null) {
            newValue[key] = ''
          } else {
            newValue[key] = this.deCapitalizeProperties(value[key])
          }
        } else {
          newValue[key] = value[key]
        }
      })
    } catch (e) {
      return newValue
    }
    return newValue
  },

  fileDownload (response, fileName) {
    const fileUrl = window.URL.createObjectURL(new Blob([response]))
    const fileLink = document.createElement('a')
    fileLink.href = fileUrl
    fileLink.setAttribute('download', fileName)
    document.body.appendChild(fileLink)
    fileLink.click()
    fileLink.remove()
  },

  failProgressBar () {
    const newVue = new Vue({})
    newVue.$Progress.fail()
  },

  generateResponseMessage (obj, actionType) {
    // error.response.status
    switch (obj.response.status) {
      // SUCCESS_OK
      case 200 :
        AlertsService.successActionAlert(`${actionType} success`)
        break

        // SUCCESS_CREATED
      case 201:
        AlertsService.successActionAlert(`${actionType} success`)
        break

        // ERROR DATA
      case 400:
        this.handleRequestErrors(obj.response.data.errors, actionType)
        return this.parseErrors(obj.response.data.errors)
        break

      case 302:
        this.handleRequestErrors(obj.response.data.errors, actionType)
        return this.parseErrors(obj.response.data.errors)
        break

        // CONFLICT for esched
      case 409:
        this.handleRequestErrors(obj.response.data.booked, 'Conflict for the following booked sched.')
        return this.parseErrors(obj.response.data.booked)
        break

        // NOT_FOUND
      case 404:
        AlertsService.errorActionAlert('Request Record not found.', actionType)
        break

        // UNAUTHORIZED
      case 401:
        AlertsService.errorActionAlert(obj.response.data.errors, actionType)
        break

      case 405:
        AlertsService.errorActionAlert('Request method not allowed.', actionType)
        break

        // INTERNAL_SERVER_ERROR
      case 500:
        AlertsService.errorActionAlert('Internal Server Error', actionType)
        break

        // INTERNAL_SERVER_ERROR
      case 501:
        AlertsService.errorActionAlert('Failed to implement', actionType)
        break

        // INTERNAL_SERVER_ERROR
      case 503:
        AlertsService.errorActionAlert('Service Un available', actionType)
        break
    }
  },

  handleRequestErrors (errorMessages, source) {
    let message = ''
    if (errorMessages) {
      Object.keys(errorMessages).forEach((key, index) => {
        message += `<p class="text-left">${index + 1}. ${errorMessages[key]}</p>`
      })
    }
    AlertsService.errorWithResponseData(message, source, 'warning')
  },

  parseErrors (errors) {
    const errorMessages = []
    Object.keys(errors).forEach(column => errorMessages[column] = errors[column].join(', '))
    return { errors: errorMessages }
  }

}

export default { GlobalUtility }
